export const WORLD = {
  WIDTH: 1280,
  HEIGHT: 480,
  GROUND_Y: 400,
} as const;

export const PHYSICS = {
  GRAVITY: 2200,
  JUMP_VELOCITY: -900,
  DUCK_FACTOR: 0.5,
} as const;

export const SPEED = {
  BASE: 360,
  RAMP_PER_SEC: 6,
  MAX: 900,
} as const;

export const SPAWN = {
  MIN_GAP_SEC: 0.85,
  MAX_GAP_SEC: 1.9,
  POWERUP_CHANCE: 0.18,
} as const;

export const PLAYER = {
  WIDTH: 60,
  HEIGHT: 90,
  DUCK_HEIGHT: 50,
  START_X: 140,
  LIVES: 3,
  INVINCIBILITY_MS: 1500,
  SHIELD_CHARGES: 3,
  SHIELD_COOLDOWN_MS: 700,
} as const;

export const OBSTACLE = {
  JUMP: { width: 44, height: 70, color: "#7a1f1f" },
  DUCK: { width: 60, height: 32, color: "#3b2c66" },
  FLY: { width: 56, height: 40, color: "#1f4e6b" },
} as const;

export const POWERUP = {
  SIZE: 38,
  DURATION_MS: 6000,
} as const;

export const PROJECTILE = {
  SIZE: 30,
  SPEED: 760,
  MAX_RANGE_PX: 900,
} as const;

export const SCORE = {
  PER_SECOND: 10,
  PER_DODGE: 25,
  COMBO_STEP: 0.1,
  COMBO_MAX: 3,
  COMBO_RESET_SEC: 1.5,
  PER_DESTROY: 50,
} as const;

export type ObstacleKind = "JUMP" | "DUCK" | "FLY";
export type PowerUpKind = "SHIELD" | "MULTIPLIER" | "LIFE";
